import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Text } from '@xingternal/winery-ui/lib/Text';
import Error from '@ui/core/assets/Error.svg';
import { Icon as BaseIcon } from '@xingternal/winery-ui/lib/Icon';
import { Render } from '@xingternal/rebranding-adapter';

export const ErrorWrapper = styled.div.attrs({
  role: 'alert',
})`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${themeGet('colors.appBackground')};
`;

export const ErrorMessage = styled(Text).attrs(() => ({
  color: 'secondaryText',
}))`
  font-size: ${themeGet('fontSizes.3')};
  margin-top: ${themeGet('space.5')};
  text-align: center;

  ${({ props }) => props}
`;

export const Icon = (props) => (
  <Render
    fallback={
      <BaseIcon name="CoreWarning" color="grey400" height={48} width={48} {...props} />
    }
  >
    <img src={Error} {...props} />
  </Render>
);
